"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./LinkList.scss");
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _checkForThemeProps = require("../../utils/checkForThemeProps");
var _LinkListMethods = require("./LinkListMethods");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const LinkList = _ref => {
  let {
    contentfulId,
    links,
    theme,
    paddingClass
  } = _ref;
  const [visible, setVisible] = (0, _react.useState)(false);
  const themes = (0, _checkForThemeProps.checkForThemeProps)(theme);
  const {
    mouse
  } = (0, _useMouse.default)();
  return /*#__PURE__*/_react.default.createElement("section", {
    className: `luna-link-list ${paddingClass} ${visible}`,
    style: {
      backgroundColor: theme?.backgroundColor || "#ffffff"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, links && links.map((link, i) => {
    return /*#__PURE__*/_react.default.createElement(_LinkListMethods.SingleLink, {
      contentfulId: link?.contentfulId,
      key: i,
      mouse: mouse,
      linkText: link?.linkText,
      destination: link?.destination,
      theme: themes,
      external: link?.external,
      icon: link?.icon,
      Link: link?.Link,
      video: link?.video,
      setVisible: setVisible,
      onClick: link?.onClick
    });
  })));
};
var _default = LinkList;
exports.default = _default;